import React, { FC } from 'react';

interface HeaderProps {
  title: string;
}

const navItems: { id: string; label: string }[] = [
  { id: 'hero', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'experience', label: 'Experience' },
  { id: 'tech', label: 'Tech' },
  { id: 'projects', label: 'Projects' },
  { id: 'widgets', label: 'Live' },
  { id: 'baseball', label: 'Baseball' },
];

const Header: FC<HeaderProps> = ({ title }) => {
  const handleScroll = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header className="sticky top-0 z-20 border-b border-fuchsia-500/30 bg-slate-950/95 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4">
        <div className="flex items-center gap-3">
          <div className="flex h-8 w-8 items-center justify-center rounded-full border border-fuchsia-400/60 bg-slate-900 text-[13px] font-semibold text-fuchsia-300 shadow-[0_0_16px_rgba(244,114,182,0.6)]">
            V
          </div>
          <div className="flex items-baseline gap-2">
            <span className="text-sm font-medium uppercase tracking-[0.2em] text-fuchsia-300">
              Software Engineer
            </span>
            <span className="text-base text-slate-500">/</span>
            <span className="text-base font-semibold text-slate-100">{title}</span>
          </div>
        </div>
        <nav className="hidden items-center gap-6 text-sm text-slate-300 sm:flex">
          {navItems.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => handleScroll(item.id)}
              className="rounded-full px-2 py-1 text-xs font-medium tracking-wide text-slate-300 transition hover:bg-fuchsia-500/20 hover:text-fuchsia-200"
            >
              {item.label}
            </button>
          ))}
          <a
            href="https://www.linkedin.com/in/nate-verlin"
            target="_blank"
            rel="noreferrer"
            className="rounded-full bg-fuchsia-500 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-slate-950 shadow-sm transition hover:bg-fuchsia-400"
          >
            Connect
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;